import React from "react";
import urlParser from "js-video-url-parser/lib/base";
import "js-video-url-parser/lib/provider/youtube";
import YouTube from "react-youtube";

const Video = ({ youtube }) => {
  const data = urlParser.parse(youtube);

  if (data && data.id) {
    return (
      <figure className="video">
        <YouTube
          videoId={data.id}
          classContainerName="youtube"
          opts={{
            playerVars: {
              modestbranding: 1,
              playsinline: 1,
              rel: 0,
            },
          }}
        />
      </figure>
    );
  } else {
    return "";
  }
};
export default Video;
